import script from "./NaturalCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./NaturalCreate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__